module.exports = __webpack_public_path__ + "3f16e137/img/lock-icon.bb9c7166.svg";